import React, { ReactNode } from 'react'
import { Box, Stack, Sx, useMantineTheme, ScrollArea, Flex } from '@mantine/core'
import { Campaign } from 'types/domain'
import { entriesPathMapping } from 'config/constants/campaignPathMapping'
import { useRouter } from 'next/router'
import GridBody from 'components/business/Campaign/List/Table/GridBody'
import { Column, RowData } from 'components/ui/ScrollableTable'
import ListBody from 'components/business/Campaign/List/Table/ListBody'
import { LayoutType } from 'components/business/Campaign/hooks/useCampaignLayoutCache'
import { getBackgroundColor, getBorderColor } from 'config/themeOverride/getColor'
import ListHeader from 'components/business/Campaign/List/Table/ListHedaer'

type Props = {
  data: any
  layout: LayoutType
  columns: Column[]
  className?: string
  footer?: ReactNode
}

const Table = ({ layout, data, columns, className, footer }: Props) => {
  const theme = useMantineTheme()
  const router = useRouter()
  const { appId } = router.query

  const handleItemClick = (campaign: Campaign) => {
    router
      .push({
        pathname: entriesPathMapping[campaign.type],
        query: { appId, campaignId: campaign.id },
      })
      .then()
  }

  const itemStyle = (data: RowData) => {
    return {
      cursor: 'pointer',
      overflow: 'hidden',
      borderRadius: '6px',
      backgroundColor: getBackgroundColor('white', theme),
      border: `1px solid ${getBorderColor('gray.1', theme)}`,
      boxShadow: '0px 8px 8px -8px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      gap: 0,
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: 4,
        backgroundColor: getBackgroundColor(data.enabled ? 'teal.3' : 'gray.3', theme),
      },
    } as Sx
  }

  return (
    <Stack h="100%" spacing={0} className={className}>
      <header style={{ paddingRight: '24px' }}>{layout === LayoutType.LIST && <ListHeader columns={columns} />}</header>
      <main className="flex-1 relative">
        <Box className="absolute" right={0} left={0} top={0} bottom={0}>
          <ScrollArea
            h={`calc(100% - ${theme.spacing.lg})`}
            styles={{
              viewport: {
                paddingRight: 24,
                paddingBottom: 0,
              },
            }}
          >
            {layout === LayoutType.GRID && <GridBody data={data} onItemClick={handleItemClick} itemStyle={itemStyle} />}
            {layout === LayoutType.LIST && (
              <ListBody data={data} onItemClick={handleItemClick} itemStyle={itemStyle} columns={columns} />
            )}
          </ScrollArea>
        </Box>
      </main>
      {footer}
    </Stack>
  )
}

export default Table
